const constants = {
  specialCharacterCheckPatternWithSpace: /^[a-z0-9\s_.-]+$/i,
  specialCharacterCheckPattern: /^[a-z0-9_.-]+$/i,
  phoneNumberCheckPattern: /^(?:\d*)$/,
baseImgUrl:"",
};
 
export default constants;
